import {
  SUPER_SYSTEM_VALIDATE_REQUEST,
  SUPER_SYSTEM_VALIDATE_SUCCESS,
  SUPER_SYSTEM_VALIDATE_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SUPER_SYSTEM_VALIDATE_REQUEST:
      return { ...state, isLoading: true, error: null };
    case SUPER_SYSTEM_VALIDATE_SUCCESS:
      return { ...state, data: [...action.payload], isLoading: false, error: null };
    case SUPER_SYSTEM_VALIDATE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
